








































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Getter, Action } from 'vuex-class';
import UserInterface from '@/types/app/IUser';
import JobInfoHeader from '@/components/headers/header-jobinfo';
import ModalSuccess from "@/components/common/ModalSuccess.vue";
import Header from '@/types/app/header';
import Endpoint from '@/utils/endpoint';
import formatMoney from '@/utils/formatMoney';
import { formatDateWithTime } from '@/utils/formatDate';
import JobInfoInterface, { jobInfoInitialValue } from '@/types/app/jobInfo';
import { use } from 'vue/types/umd';
import { Watch } from 'vue-property-decorator';

const namespace = 'customer';

@Component({
  components: { ModalSuccess }
})
export default class ModalDetail extends Vue {
  @Getter('getModalJobInfoState', { namespace })
  modalJobInfoState!: boolean;
  @Getter('getUser', { namespace: 'auth' }) user!: UserInterface;

  @Action('setModalJobInfoState', { namespace })
  setModalJobInfoState!: any;
  headers: Header[] = JobInfoHeader.header;
  private endpoint = new Endpoint();
  formatDateWithTime = formatDateWithTime;
  formatMoney = formatMoney;

  openSuccessModal = false;
  loading = false;

  singleSelect = true;
  selectedJob: JobInfoInterface[] = [];
  jobs: JobInfoInterface[] = [];


  @Watch("modalJobInfoState")
  async fetchCaches() {
    if(!this.modalJobInfoState)
      return;
    this.loading = true;
    const [productItem, accountItem, customerItem] = await Promise.all([
      this.getProductCaches(),
      this.getAccountCaches(),
      this.getCustomerCaches()
    ]);

    this.jobs = [];
    this.jobs.push(productItem);
    this.jobs.push(accountItem);
    this.jobs.push(customerItem);
    this.loading = false;
  }

  async triggerNow() {
    if (this.selectedJob.length == 1) {
      this.loading = true;

      try {
        const url =
          this.selectedJob[0].jobId == 'RefreshCache-ProductApi'
            ? this.endpoint.productClearCache
            : this.selectedJob[0].jobId == 'RefreshCache-InvestmentApi' ? this.endpoint.accountsClearCache : this.endpoint.customerClearCache;
        const result = await this.$http.put(url);
        
        
        this.selectedJob = [];
        this.jobs = [];
        this.openSuccessModal = true;
        await this.fetchCaches();     
        
        //await new Promise(r => setTimeout(r, 2000));           
        this.loading = false;
      } catch (error) {
        console.error('handleProducts', error);
      }
    }
  }

  async getProductCaches(): Promise<JobInfoInterface> {
    const { data: item } = await this.$http.get(this.endpoint.productGetCache);
    return item.jobInfo;
  }

  async getCustomerCaches(): Promise<JobInfoInterface> {
    const { data: item } = await this.$http.get(this.endpoint.customerGetCache);
    return item.jobInfo;
  }

  async getAccountCaches(): Promise<JobInfoInterface> {
    const { data: item } = await this.$http.get(this.endpoint.accountsGetCache);
    return item.jobInfo;
  }

  closeModal(): void {
    this.setModalJobInfoState(false);
  }
}
